import React from "react";
import { POINT_OUTCOMES } from "../utils/matchPointLabel";
import "./PointOutcomeBar.css";

export default function PointOutcomeBar({
  t,
  activeOutcome = null,
  disabled = false,
  onSelect,
  className = "",
}) {
  const translate = typeof t === "function" ? t : (_key, fallback) => fallback;
  return (
    <div
      className={`cm-outcome${className ? ` ${className}` : ""}`}
      role="group"
      aria-label={translate("cmTagPoint", "Tag this point")}
    >
      {POINT_OUTCOMES.map((item) => {
        const on = activeOutcome === item.id;
        return (
          <button
            key={item.id}
            type="button"
            className={`cm-outcome__btn cm-outcome__btn--${item.id}${on ? " is-on" : ""}`}
            aria-pressed={on}
            aria-label={translate(item.titleKey, item.title)}
            title={translate(item.titleKey, item.title)}
            disabled={disabled}
            onClick={() => onSelect?.(item.id)}
          >
            <span className="cm-outcome__mark" aria-hidden>
              {item.mark}
            </span>
            <span className="cm-outcome__text">
              {translate(item.labelKey, item.label)}
            </span>
          </button>
        );
      })}
    </div>
  );
}
